// Format ISO 8601 timestamp -> "5min ago", "2h ago", "yesterday", "3d ago".
// Operator usa pra "freshness" indicator (Splunk SOC pattern).

interface RelativeTimeProps {
  ts: string | null | undefined;
  className?: string;
  /** Now reference (override for testing). Defaults to Date.now(). */
  now?: Date;
}

export function formatRelative(ts: string | null | undefined, now: Date = new Date()): string {
  if (!ts) return '—';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return '—';
  const diffMs = now.getTime() - d.getTime();
  if (diffMs < 0) return 'no futuro';

  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return `${sec}s atrás`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}min atrás`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours}h atrás`;
  const days = Math.floor(hours / 24);
  if (days === 1) return 'ontem';
  if (days < 30) return `${days}d atrás`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mês atrás`;
  const years = Math.floor(months / 12);
  return `${years}a atrás`;
}

export function RelativeTime({ ts, className = '', now }: RelativeTimeProps) {
  const text = formatRelative(ts, now);
  const titleStr = ts ?? '';
  return (
    <span className={`text-xs text-gray-500 ${className}`} title={titleStr}>
      {text}
    </span>
  );
}
